export const routes = [
  {
    path: '/',
    name: 'vip',
    component: () => import(/* webpackChunkName: "about" */ './views/MoreInfo.vue')
  },
  {
    path: '/old',
    name: 'old',
    component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
  },
  {
    path: '/details/:id',
    name: 'details',
    component: () => import('./views/ArticleDetail.vue')
  },
  {
    path: '/more',
    name: 'more', // 查看更多
    component: () => import('./views/MoreInfo.vue')
  },
  {
    path: '/search',
    name: 'search', // 搜索
    component: () => import('./views/SearchInfo.vue')
  },
  {
      path: '/example',
      name: 'vip',
      component: () =>
          import ( /* webpackChunkName: "about" */ './views/Example.vue')
  },
]